import PocketBase, { isTokenExpired } from "pocketbase";
import { Collections, type TypedPocketBase } from "@/types/pocketbase";

const EXPIRATION_THRESHOLD_SECONDS = 300;

export const pb = new PocketBase() as TypedPocketBase;

pb.autoCancellation(false);

pb.afterSend = async (response, data: unknown) => {
	const authStatus = response.headers.get("X-Auth-Status") as "valid" | "invalid";

	const isAuthEndpoint = response.url.includes("auth");

	if (!isAuthEndpoint && authStatus === "invalid") {
		await logout();
	}

	return data;
};

export const logout = () => {
	pb.authStore.clear();

	window.location.href = `/auth/login?redirectTo=${window.location.pathname}`;

	return Promise.resolve();
};

export const refreshSession = async (cb: (() => void) | undefined = undefined) => {
	if (!(pb.authStore.token && isTokenExpired(pb.authStore.token, EXPIRATION_THRESHOLD_SECONDS))) {
		return;
	}

	try {
		const response = await pb.collection(Collections.Doctors).authRefresh();
		return response.record;
	} catch {
		cb?.();
		logout();
	}
};
